import { Injectable } from '@angular/core';
import { CommonService } from '../common_services/common.service';
import { DataCommunicationService } from '../data_service/data-communication.service';
import { AutheticationService } from '../authentication/authetication.service';
import { LoaderindicatorService } from '../loaderindicator/loaderindicator.service';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CampaignRedirectionService {

  showError = false;
  currentData: any;

  constructor(
    private commonService: CommonService,
    private dataCommunicationService: DataCommunicationService,
    private autheticationService: AutheticationService,
    private readonly loadingIndicatorService: LoaderindicatorService,
  ) { }

  public getDealerByDMSNo(DmsNo,MobileNo){
    return new Promise((resolve)=>{
      this.autheticationService.login().pipe(first()).subscribe(result => {
        //this.loadingIndicatorService.hide();
        this.dataCommunicationService.getDealerByDmsNo({DmsId : DmsNo}).subscribe(result =>{
          this.commonService.setLocalStorage('dealerImage', 'data:image/jpeg;base64,' + result.Data.DealerImage);
          this.commonService.setLocalStorage('managerName', result.Data.ManagerName);
          this.commonService.setLocalStorage('dealername', result.Data.Id);
          this.getCustomerData(MobileNo).then(res=>{
            resolve();
          });          
        });           
      }, error => {
        this.loadingIndicatorService.hide();
      });
    })    
  }

  public getCustomerData(MobileNo){
    return new Promise((resolve)=>{
      this.dataCommunicationService.getCustomerDetailByMobile(MobileNo)
      .subscribe(result => {
        if (result.StatusCode === 1) {
          this.commonService.setLocalStorage('customerData', result.Data);
          this.PushDataToAnalytics('true');
        } else {
          this.PushDataToAnalytics('false');
        }
        resolve();
      }, error => {
        this.PushDataToAnalytics('false');
        this.showError = true;        
        this.loadingIndicatorService.hide();
    });
    }) 
  }

  public PushDataToAnalytics(value) {
    this.currentData = {
      'event': 'PhoneValidation',
      'so-customer': value
    };
    (window as any).dataLayer.push(this.currentData);
  }
}
